module.exports = __webpack_public_path__ + "static/media/ærlig.83dfaafa.m4a";